import React, { useEffect, useState } from 'react';
import { api } from '../../utils/api';

const WorkerProjects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const response = await api.getProjects();
      setProjects(response.data);
    } catch (error) {
      console.error('Failed to fetch projects:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="p-6">Laddar...</div>;
  }

  return (
    <div className="p-6 space-y-6" data-testid="worker-projects-page">
      <h2 className="text-xl font-semibold text-foreground" style={{ fontFamily: 'Work Sans' }}>Mina projekt</h2>
      
      {projects.length === 0 ? (
        <div className="bg-card rounded-xl shadow-sm border border-border p-8 text-center text-muted-foreground">
          Inga projekt tillgängliga
        </div>
      ) : (
        <div className="space-y-3">
          {projects.map((project) => (
            <div key={project.id} className="bg-card rounded-xl shadow-sm border border-border p-6">
              <h3 className="font-semibold text-foreground mb-2">{project.name}</h3>
              <div className="space-y-1 text-sm text-muted-foreground">
                <p>Kund: {project.customer || '-'}</p>
                <p>Plats: {project.location || '-'}</p>
                <p>Status: {project.status}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default WorkerProjects;
